import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';
import { Dialog, Button, DialogTitle, DialogContent, Icon, CircularProgress } from '@material-ui/core';
// import PDFViewer from 'pdf-viewer-reactjs'
import PDFViewer from '../../../components/pdfViewer'

class Corte extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'corte/one', saveUrl: 'corte/save', backUrl: '/Catalogo' },
      new Form([
        Form.Field('date', 'startDate', 'Fecha Inicial', '', [Validators.required], 6),
        Form.Field('date', 'endDate', 'Fecha Final', '', [Validators.required], 6),
      ], ['Generar pdf'], 'Corte Reporte'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  setOpenPrint = (openPrint) => {
    this.setState({ openPrint, loadingVisImp: openPrint })
  }

  handleDonwnloadExcel = async () => {
    this.setState({ loading: true });
    const { startDate, endDate } = this.state;
    const start = moment(startDate).format('YYYY-MM-DD')
    const end = moment(endDate).format('YYYY-MM-DD')
    const Resp = await Http.get(`reporte/excelcorte?q=1&start_date=${start}&end_date=${end}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `reporte.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loading: false });
  }

  onSubmit  = async (i, vals) => {
    this.setState({ loading: true });
    const { startDate, endDate } = vals;
    const start = moment(startDate).format('YYYY-MM-DD')
    const end = moment(endDate).format('YYYY-MM-DD')
    const Resp = await Http.get(`reporte/corte-pdf?q=1&start_date=${start}&end_date=${end}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      this.setState({
        pdfURL: url,
        openPrint: true, 
        loadingVisImp: true,
        startDate,
        endDate,
      });
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loading: false });
  }
  handleAcceptPrint = () => {
    const { pdfURL } = this.state;
    const printWin = window.open(pdfURL, 'Corte', 'width=1050,height=800');
    printWin.focus();
    printWin.print();
    URL.revokeObjectURL(pdfURL);
    this.setOpenPrint(false);
  }

  render() {
    const { pdfURL, openPrint = false, loading } = this.state;
    return (
      <div>
        <this.FormRender />
        <Dialog fullWidth={false} maxWidth={'lg'} onClose={() => { this.setOpenPrint(false) }} open={openPrint} >
            <DialogTitle onClose={() => { this.setOpenPrint(false) }}>
              Corte
          </DialogTitle>
            <DialogContent dividers >
              <div>
                {
                  pdfURL !== '' && (
                    <div className='pdf-viewer'>
                      <PDFViewer
                        pdfUrl={pdfURL}
                        scale={1}
                        style={{ height: 400 }}
                        document={{
                          url: pdfURL,
                        }}
                      />
                      <div style={{ padding: '0px 15px', display: 'flex', width: '100%', justifyContent: 'space-between' }} >
                        <Button
                          variant="contained"
                          onClick={() => {
                            this.setOpenPrint(false);
                          }}
                        >
                          Cerrar
                      </Button>
                      <Button
                        disabled={loading}
                        variant="contained"
                        onClick={this.handleDonwnloadExcel}
                      >
                        <div style={{ marginRight: 10, padding: 0, height: 22 }} hidden={!loading}>
                          <CircularProgress color="secondary" size={20} />
                        </div>
                        Descargar Excel
                      </Button>
                      <Button
                        variant="contained"
                        endIcon={<Icon>print</Icon>}
                        onClick={this.handleAcceptPrint}
                      >
                          Imprimir
                      </Button>
                      </div>
                    </div>
                  )
                }
              </div>
            </DialogContent>
          </Dialog>
      </div>
    )
  }
}

export default withRouter(Corte)
